module.exports = __webpack_public_path__ + "static/img/logo_footer.ef50843.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_footer.svg
// module id = 448
// module chunks = 2